var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.opened),expression:"opened"}],staticClass:"modal-reuniao"},[_c('div',{staticClass:"modal-reuniao-content shadow-sm"},[_c('calendario-reuniao',{attrs:{"componente":"true"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }